var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_88_232)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 49,
    height: 49,
    fill: "#02FF75"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 51,
    height: 51,
    stroke: "black",
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.48 8H9.52C8.67925 8 8 8.67925 8 9.52V44.48C8 45.3208 8.67925 46 9.52 46H44.48C45.3208 46 46 45.3208 46 44.48V9.52C46 8.67925 45.3208 8 44.48 8ZM37.2267 21.7608C37.241 21.984 37.241 22.2168 37.241 22.4447C37.241 29.4177 31.9305 37.45 22.2262 37.45C19.2337 37.45 16.4597 36.5807 14.1227 35.0845C14.5502 35.132 14.9588 35.151 15.3958 35.151C17.8658 35.151 20.1363 34.315 21.946 32.8995C19.628 32.852 17.6805 31.332 17.0155 29.242C17.8277 29.3608 18.5592 29.3608 19.3952 29.147C18.2017 28.9045 17.1289 28.2563 16.3591 27.3125C15.5893 26.3686 15.1701 25.1874 15.1725 23.9695V23.903C15.8707 24.2972 16.6925 24.5395 17.5522 24.5728C16.8295 24.0911 16.2368 23.4385 15.8266 22.6729C15.4165 21.9073 15.2016 21.0523 15.201 20.1838C15.201 19.2005 15.4575 18.3027 15.9183 17.5238C17.243 19.1546 18.8962 20.4884 20.7702 21.4385C22.6442 22.3886 24.6972 22.9338 26.7957 23.0385C26.05 19.4523 28.729 16.55 31.9495 16.55C33.4695 16.55 34.8375 17.1865 35.8017 18.2125C36.994 17.9893 38.134 17.5427 39.1505 16.9442C38.7562 18.165 37.9298 19.1957 36.8325 19.8465C37.8965 19.7325 38.9225 19.438 39.8725 19.0247C39.1552 20.0793 38.2575 21.015 37.2267 21.7608Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_88_232",
    x: 0,
    y: 0,
    width: 57,
    height: 57,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_88_232"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_88_232",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.14d76b3824652870f5238bba919ef5d9.svg";
export { ForwardRef as ReactComponent };